const mergeObject = require('hobbit-base/modules/plugins/mergeObject');
const prodConfig = require('./prod');

// 只需定义要覆盖线上配置的内容即可
module.exports = mergeObject(prodConfig, {
  runtime: 'test',
  site: {
    publicPath: `https://s.vipkidstatic.com/fe-static/hobbit-sa-school/test/${process.env.VUE_APP_DRONE || 'default'}/`,
    outputDir: 'dist/test',
    vconsole: false,
  },
  log: {
    saUrl: 'https://sensorsdata.vipkid.com/sa?project=test',
    consoleLog: true,
  },
  resources: {
    file: 'https://vipkid-static-oss.oss-cn-beijing.aliyuncs.com/fe-static/int/translate/test_{appName}_{lang}.js',
    cacheExpires: 1 * 1000, // 资源缓存刷新间隔时间（毫秒数）
  },
  custom: {
    faqIMUrl: 'https://stage-global-school.vipkid-qa.com.cn/{lang}/faqim/',
    whiteListTagID: 4,
  },
});
